import { render, staticRenderFns } from "./_mobileplate.vue?vue&type=template&id=358ef306&scoped=true"
import script from "./_mobileplate.vue?vue&type=script&lang=js"
export * from "./_mobileplate.vue?vue&type=script&lang=js"
import style0 from "./_mobileplate.vue?vue&type=style&index=0&id=358ef306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ef306",
  null
  
)

export default component.exports